export default "__VITE_ASSET__CmH6dBCc__"